export const US_STATES: { value: string; label: string }[] = [
  { value: '', label: 'Select a state' },
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
];

export const ZONES: { value: string; label: string }[] = [
  { value: '', label: 'Select a zone' },
  { value: 'northern_midwest', label: 'Northern Midwest' },
  { value: 'mid_midwest_south', label: 'Mid-Midwest / South' },
  { value: 'deep_south', label: 'Deep South' },
];

// Auto-suggest a zone from the selected state.
// Returns '' if no mapping exists (user must pick manually).
const STATE_TO_ZONE: Record<string, string> = {
  // Northern Midwest — cold, early frost, long winters
  WI: 'northern_midwest',
  MI: 'northern_midwest',
  MN: 'northern_midwest',
  IA: 'northern_midwest',
  ND: 'northern_midwest',
  SD: 'northern_midwest',
  NE: 'northern_midwest',
  IL: 'northern_midwest',
  IN: 'northern_midwest',
  OH: 'northern_midwest',
  // Mid-Midwest / South — transitional belt
  MO: 'mid_midwest_south',
  KS: 'mid_midwest_south',
  KY: 'mid_midwest_south',
  TN: 'mid_midwest_south',
  VA: 'mid_midwest_south',
  NC: 'mid_midwest_south',
  WV: 'mid_midwest_south',
  PA: 'mid_midwest_south',
  NY: 'mid_midwest_south',
  MD: 'mid_midwest_south',
  DE: 'mid_midwest_south',
  NJ: 'mid_midwest_south',
  CT: 'mid_midwest_south',
  RI: 'mid_midwest_south',
  MA: 'mid_midwest_south',
  VT: 'mid_midwest_south',
  NH: 'mid_midwest_south',
  ME: 'mid_midwest_south',
  // Deep South — warm, late season activity
  TX: 'deep_south',
  LA: 'deep_south',
  MS: 'deep_south',
  AL: 'deep_south',
  GA: 'deep_south',
  FL: 'deep_south',
  SC: 'deep_south',
  AR: 'deep_south',
  OK: 'deep_south',
};

export function zoneForState(state: string): string {
  return STATE_TO_ZONE[state] ?? '';
}
